import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Button } from './ui/button';
import { Sun, Moon } from 'lucide-react';

export default function Header() {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <header className="glass-header sticky top-0 z-50 border-b bg-background/70" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
            <img src="/logo.png" alt="VerdictIQ" className="h-10 w-10 object-contain transition-transform group-hover:scale-105" />
            <span className="font-serif font-bold text-lg hidden sm:inline">VerdictIQ</span>
          </Link>
          <div className="flex items-center gap-1">
            <Link to="/pricing">
              <Button
                variant={isActive('/pricing') ? 'default' : 'ghost'}
                size="sm"
                className="rounded-full h-8 px-4 text-xs sm:text-sm"
                data-testid="nav-pricing"
              >
                Pricing
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant={isActive('/contact') ? 'default' : 'ghost'}
                size="sm"
                className="rounded-full h-8 px-4 text-xs sm:text-sm"
                data-testid="nav-contact"
              >
                Contact
              </Button>
            </Link>
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleTheme}
              className="rounded-full ml-1"
              data-testid="theme-toggle"
            >
              {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
